import { IJwtToken } from '/common/models';

export function parseToken(token: string): IJwtToken | undefined {
  const parts = token.split('.');
  try {
    return JSON.parse(atob(parts[1])) as IJwtToken;
  } catch (_e) {
    console.error(`Can't parse token`);
    return undefined;
  }
}
